import { render, staticRenderFns } from "./ImportUsers.vue?vue&type=template&id=0a2352cd&scoped=true&"
import script from "./ImportUsers.vue?vue&type=script&lang=js&"
export * from "./ImportUsers.vue?vue&type=script&lang=js&"
import style0 from "./ImportUsers.vue?vue&type=style&index=0&id=0a2352cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2352cd",
  null
  
)

export default component.exports